<ng-scrollbar [autoHeightDisabled]="true" [disabled]="scrollDisabled" [ngClass]="{'no-scroll': scrollDisabled}">
  <app-nav-bar></app-nav-bar>
  <router-outlet></router-outlet>
  <app-footer-bar></app-footer-bar>
</ng-scrollbar>
